import { Injectable } from '@angular/core';


@Injectable()
export class CategoriesService {
    categories=[{
        name:"Banka & Sigortacılık Hizmetleri",
        uniqueName:'banka_ve_sigortacilik_hizmetleri'
    },
    {
    name:'Beyaz Eşya & Elektrikli Ev Aletleri',
    uniqueName:'beyaz_esya_ve_elektrikli_ev_aletleri'
    },{
        name:'E-Ticaret Siteleri',
        uniqueName:'eticaret_siteleri'
    },{
        name:'Ev, Yaşam & Ofis',
        uniqueName:'ev_yasam_ve_ofis'
    },{
        name:'Gıda & Hızlı Tüketim',
        uniqueName:'gida_ve_hizli_tuketim'
    },
{
    name:'İnternet & Telekomünikasyon',
        uniqueName:'internet_ve_telekomunikasyon'
},{
        name:'Moda, Giyim & Aksesuar',
        uniqueName:'moda_giyim_ve_aksesuar'
},{
    name:'Sağlık, Güzellik & Kozmetik',
    uniqueName:'saglik_guzellik_ve_kozmetik'

},{
    name:'Spor & Aktif Yaşam',
    uniqueName:'spor_ve_aktif_yasam'

},{
    name:'Teknoloji & Elektronik',
    uniqueName:'teknoloji_ve_elektronik'

},{
    name:'Ulaştırma & Lojistik',
    uniqueName:'ulastirma_ve_lojistik'

}]
categoriesFooter=[{
    name:"Banka & Sigortacılık Hizmetleri",
    uniqueName:'banka_ve_sigortacilik_hizmetleri'
},
{
name:'Beyaz Eşya & Elektrikli Ev Aletleri',
uniqueName:'beyaz_esya_ve_elektrikli_ev_aletleri'
},{
    name:'E-Ticaret Siteleri',
    uniqueName:'eticaret_siteleri'
},{
    name:'Gıda & Hızlı Tüketim',
    uniqueName:'gida_ve_hizli_tuketim'
},
{
name:'İnternet & Telekomünikasyon',
    uniqueName:'internet_ve_telekomunikasyon'
},
{
    name:'Moda, Giyim & Aksesuar',
    uniqueName:'moda_giyim_ve_aksesuar'
},
,{
name:'Teknoloji & Elektronik',
uniqueName:'teknoloji_ve_elektronik'

}]



  constructor() { }


  initialize() {
   
  }
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/categories.service.ts